module.exports = __webpack_public_path__ + "static/media/annual-report.3658522b.svg";